import { useEffect, useState } from 'react';

/**
 * This hook receives a boolean that indicates whether the component that is using it
 * is mounted and then delays the mount for a certain amount of time (delayTime).
 * This is especially useful when we need to run some exit animation
 * before the component is unmounted.
 */
function useDelayUnmount(isMounted: boolean, delayTime: number): boolean {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(() => setShouldRender(false), delayTime);
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);

  return shouldRender;
}

export default useDelayUnmount;
